import gsap from "gsap"

export default class Animation {
    constructor() {
        this.activeTweens = new Map()
        this.activeRotationTweens = new Map()
    }

    pressButton(object, textMesh = null) {
        if (!object) {
            return
        }

        const baseZ = object.userData.baseZ ?? object.position.z
        object.userData.baseZ = baseZ

        const existingTween = this.activeTweens.get(object.uuid)
        if (existingTween) {
            existingTween.kill()
        }

        let textBaseZ = null
        if (textMesh) {
            textBaseZ = textMesh.userData.baseZ ?? textMesh.position.z
            textMesh.userData.baseZ = textBaseZ
            console.log("Animation.pressButton - animating textMesh:", textMesh.name, "from baseZ:", textBaseZ, "position.z:", textMesh.position.z)
            const existingTextTween = this.activeTweens.get(textMesh.uuid)
            if (existingTextTween) {
                existingTextTween.kill()
            }
        }

        const timeline = gsap.timeline({
            onComplete: () => {
                this.activeTweens.delete(object.uuid)
                if (textMesh) {
                    this.activeTweens.delete(textMesh.uuid)
                }
            }
        })

        timeline.to(object.position, {
            z: baseZ + 0.1,
            duration: 0.08,
            ease: "power2.out"
        }, 0)

        timeline.to(object.position, {
            z: baseZ,
            duration: 0.16,
            ease: "power2.out"
        }, 0.08)

        if (textMesh && textBaseZ !== null) {
            timeline.to(textMesh.position, {
                z: textBaseZ + 0.1,
                duration: 0.08,
                ease: "power2.out"
            }, 0)

            timeline.to(textMesh.position, {
                z: textBaseZ,
                duration: 0.16,
                ease: "power2.out"
            }, 0.08)
        }

        this.activeTweens.set(object.uuid, timeline)
        if (textMesh) {
            this.activeTweens.set(textMesh.uuid, timeline)
        }
    }

    pressDpad(object, direction) {
        if (!object) {
            return
        }

        const baseRotation = object.userData.baseRotation ?? {
            x: object.rotation.x,
            y: object.rotation.y,
            z: object.rotation.z
        }

        object.userData.baseRotation = baseRotation

        const existingTween = this.activeRotationTweens.get(object.uuid)
        if (existingTween) {
            existingTween.kill()
        }

        const rotationOffset = this.getDpadRotationOffset(direction)
        const timeline = gsap.timeline({
            onComplete: () => {
                this.activeRotationTweens.delete(object.uuid)
            }
        })

        timeline.to(object.rotation, {
            x: baseRotation.x + rotationOffset.x,
            y: baseRotation.y + rotationOffset.y,
            duration: 0.08,
            ease: "power2.out"
        })

        timeline.to(object.rotation, {
            x: baseRotation.x,
            y: baseRotation.y,
            duration: 0.16,
            ease: "power2.out"
        })

        this.activeRotationTweens.set(object.uuid, timeline)
        this.pressButton(object)
    }

    getDpadRotationOffset(direction) {
        switch (direction) {
            case "up":
                return { x: 0.12, y: 0 }
            case "down":
                return { x: -0.12, y: 0 }
            case "left":
                return { x: 0, y: -0.12 }
            case "right":
                return { x: 0, y: 0.12 }
            default:
                return { x: 0, y: 0 }
        }
    }
}
